<template lang="html">


  <div class="slds-form-element slds-form-element_horizontal">

    <div class="pippo ">
      <table class="slds-table slds-table_cell-buffer slds-table_bordered slds-table_col-bordered slds-table_striped">

        <thead>
          <tr class="slds-line-height_reset">
            <th v-for="(option) in options" v-bind:key="option.order" style="vertical-align:top" >
              <span class="pippo"  style="white-space: normal" >
                {{$t(option.label)}}
              </span>

            </th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(record, rindex) in values" v-bind:key="record.id" class="slds-hint-parent">

            <td v-for="(col,index) in options" v-bind:key="col.order" v-bind:style="'text-align:'+align(col.type)" class="">

              <span class="slds-truncate">
                
                <gnetFormField2 v-bind:key="index"  v-bind:type="col.type" v-bind:name="col.name" v-bind:options="col.options"
                  v-bind:value="record[col.name]" v-bind:placeholder="col.placeholder" v-on:change="changeField(rindex, col.name, $event)"
                  v-bind:disabled="col.disabled" />

              </span>

            </td>
            <td>
              <span v-on:click="remove(rindex)" class="slds-icon_container slds-icon-utility-delete" title="Description of icon when needed">
                <svg class="slds-icon slds-icon-text-default slds-icon_x-small" aria-hidden="true">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#delete"></use>
                </svg>
              <span class="slds-assistive-text">Delete</span>
              </span>


              <!--
              <span class="slds-truncate" v-on:click="remove(rindex)">
                X
              </span>
              -->
            </td>

          </tr>

          <tr class="slds-hint-parent">
<!--
            <td v-for="(col2,index2) in options" v-bind:key="col2.order" v-bind:style="'text-align:'+align(col2.type)" class="slds-truncate">

              <span class="slds-truncate" v-on:click="$emit('add')">
                ++++

                <gnetFormField2 v-if="false" v-bind:key="1000+index2"  v-bind:type="col2.type" v-bind:name="col2.name" v-bind:options="col2.options"
                  v-bind:value="newrecord[col2.name]" v-bind:placeholder="col2.placeholder" v-on:change="changeField(-1, col2.name, $event)"
                  v-bind:disabled="col2.disabled" />

              </span>

            </td>
            <td>
            </td>
-->
            <td v-bind:colspan="options.length" class="slds-truncate" v-on:click="$emit('add')">

              <span class="slds-icon_container slds-icon-utility-insert_template" title="Description of icon when needed">
                <svg class="slds-icon slds-icon-text-default slds-icon_small" aria-hidden="true">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#insert_template"></use>
                </svg>
              <span class="slds-assistive-text">Insert</span>
              </span>
<!--
              <span class="slds-truncate" >
                ADD              
              </span>
-->
            </td>

          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
import gnetFormField2 from '../components/formfield2.vue'

export default {
  name: 'formtable',
  components: {
    gnetFormField2
//    myfield: function() { import('../components/formfield.vue')    }
  },
  props: {
    id: String,
    value: [String, Number, Date],
    options: Array,
    title: String,
    type: String,
    tabindex: Number,
    disabled: Boolean,
    placeholder: String,
    hform: Boolean,
    tip: String,
    format: String // json, picklist
  },
  computed: {
    values: function() {
      console.log('values:'+this.format);
      console.log('values='+this.value);

      if (this.format=='json' && this.value) return JSON.parse(this.value);
      if (this.format=='picklist' && this.value) return this.value.split(';');
      return [];
    }
  },
  data() {
    return {
      show: false,
      newrecord:{},
      showtip:false
    }
  },
  async created() {

  },
  methods: {
    remove: function(rindex) {
      this.$emit('remove', rindex );
    },
    changeField: function(s, f, v) {
      console.log('formtable: changeField='+v)
      this.$emit('change', { section: s, field:f, value: v} )
      if (s<0) {
        console.log('cancella:'+f)
        this.newrecord[f]='';
        var self=this;
        this.$nextTick(function() {
          self.$set(self.newrecord,f,'');
        })
      }
    },
    align: function(type) {
      switch(type) {
        case 'currency':
        case 'decimal':
          return 'right';
      }
      return 'left';
    },

  }
}
</script>

<style lang="scss" scoped>

</style>
